import { useForm, Controller } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField, Checkbox } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dateFormatter,
  dropdownFetch,
  getCurrentDateTime,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';

const PATIENT_TABLE_HEADER = [
  { header: 'UHID', accessor: 'uhid' },
  { header: 'OP No', accessor: 'op_no' },
  { header: 'Created At', accessor: 'createdAt' },
  { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name}` },
  { header: 'Mobile No', accessor: 'address.mobile' },
  { header: 'Doctor', accessor: 'consultant.name' },
  { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
  {
    header: ' Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor'
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const ADD_Surgery = [
  {
    header: 'IPD No.',
    accessor: 'ipd_no'
  },
  {
    header: 'UHID No.',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => row?.patient?.name
  },
  {
    header: 'ADM. Date',
    accessor: (row) => dateFormatter(row?.date)
  }
];

const IPD_TABLE_COLUMNS = [
  {
    header: 'IPD No.',
    accessor: 'ipd_no'
  },
  {
    header: 'UHID No.',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => row?.patient?.name
  },
  {
    header: 'ADM. Date',
    accessor: (row) => `${dateFormatter(row?.date)} ${row.time}`
  }
];

const ADD_Diagnosis = [
  {
    header: 'Descript',
    accessor: (row) => row.deficiency_checklist
  },
  {
    header: 'Remarks',
    accessor: ''
  }
];

const initialOPDBillingDataObj = {
  data: [],
  loading: false
};

const initialIndoorregistrationDataObj = {
  data: [],
  loading: false
};

const initialDeficiencyDataObj = {
  data: [],
  loading: false
};

const initialDeficiencyDataObjs = {
  data: [],
  loading: false
};

export const DeficiencyChecklist = () => {
  const doctorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOPDBillingDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [complaints, setComplaints] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [medicineDetailList, setmedicineDetailList] = useState([]);
  const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
  const [addComplaintDialogueOpen, setAddComplaintDialogueOpen] = useState(false);
  const [addDiagnosDialogOpen, setAddDiagnosDialogOpen] = useState(false);
  const [diagnos, setDiagnos] = useState([]);
  const [addMedicineDialogue, setAddMedicineDialogue] = useState(false);
  const [patientVitals, setPatientVitals] = useState([]);
  const [input, setInput] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [pastComplaints, setPastComplaints] = useState([]);
  const [pastDiagnos, setPastDiagnos] = useState([]);
  const [pastService, setPastService] = useState([]);
  const [pastMedicine, setPastMedicine] = useState([]);
  const [ipdRegistrationOpenDialogue, setIpdRegisterationOpenDialogue] = useState(false);
  const [ipdInput, setIpdInput] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState([]);

  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialIndoorregistrationDataObj);
  const [ipdFilterData, setIpdFilterData] = useState([]);
  const [deficiencyChecklistDataObj, setDeficiencyChecklistDataObj] = useState(initialDeficiencyDataObj);
  const [deficiencyChecklistDataObjs, setDeficiencyChecklistDataObjs] = useState(initialDeficiencyDataObjs);
  const [inputValues, setInputValues] = useState({});

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        ipd_no: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      adm_date: new Date().toISOString().split('T')[0],
      discharge_date: new Date().toISOString().split('T')[0],
      analysis_date: new Date().toISOString().split('T')[0],

      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  useEffect(() => {
    getDepartmentDropdown();
  }, getDepartmentDropdown);

  const formSubmit = async (formValues) => {
    if (selectedRows.length === 0 || !watch('ipd_no')) {
      toast('Please add the CheckList  first', { variant: 'warning' });
      return;
    }
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/' : '/deficiency-checklists-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: { ...formValues, checklist: selectedRows }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Deficiency CheckList`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      handleFetchDeficiencyChecklists();
      setSelectedRows([]);
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Deficieny CheckList`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (opdBillingDataObj.data && opdBillingDataObj.data.length > 0) {
      setOriginalData(opdBillingDataObj.data);
      setIsFiltered(false);
    }
  }, [opdBillingDataObj.data]);

  const handleUhidSearch = () => {
    const lowercasedInput = input.toLowerCase();
    console.log('HELLO BILLING DATA OBJ', opdBillingDataObj);
    const filtered = opdBillingDataObj.data.filter(
      (item) =>
        item?.uhid?.toString().toLowerCase().includes(lowercasedInput) ||
        item?.patient?.name?.toLowerCase().includes(lowercasedInput) ||
        item?.patient?.mobile_no?.toLowerCase().includes(lowercasedInput)
    );
    setOriginalData(filtered);
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
    handleUhidSearch();
  };

  const handleIpdChange = (e) => {
    setIpdInput(e.target.value)
  };

  const fetchIpdPatient = async () => {
    setIpdRegisterationOpenDialogue(true);
    setIndoorRegisterationDataObj({ loading: true });
    const response = await request('/indoor-registeration-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter((item) => item.admission_status === 'discharged');
      setIndoorRegisterationDataObj({ loading: false, data: filteredData });
      setIpdFilterData({ data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };

  const handleIpdRow = (row) => {
    setValue('ipd_no', row?.ipd_no);
    setValue('uhid', row?.uhid);
    setValue('patient_name', row?.patient?.name);
    setValue('consultant', row?.consultant_detail?.doctor?.name);
    setValue('ward', row?.consultant_detail?.room?.ward?.name);
    const formattedRegDate = row?.date ? new Date(row?.date).toISOString().split('T')[0] : '';
    setValue('adm_date', formattedRegDate);
    const formattedDischargeDate = row?.discharge_date ? new Date(row?.discharge_date).toISOString().split('T')[0] : '';
    setValue('discharge_date', formattedDischargeDate);
    setIpdRegisterationOpenDialogue(false);
  };

  const handleFetchDeficiencyChecklist = async () => {
    const response = await request('/deficiency-checklist-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDeficiencyChecklistDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDeficiencyChecklistDataObj({ loading: false });
    }
  };
  useEffect(() => {
    handleFetchDeficiencyChecklist();
  }, []);

  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }

    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }

    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);

      if (existingRow) {
        const updatedRows = prevSelectedRows.map((selectedRow) =>
          selectedRow._id === row._id ? { ...selectedRow, [field]: !existingRow[field] } : selectedRow
        );
        return updatedRows.filter((row) => row.ok || row.doc || row.Remarks?.trim());
      } else {
        return [
          ...prevSelectedRows,
          { _id: row._id, [field]: true, ok: field === 'ok', doc: field === 'doc', Remarks: row.Remarks || '' }
        ];
      }
    });
  };

  useEffect(() => {
    console.log('Selected rows have changed:', selectedRows);
  }, [selectedRows]);

  const handleInputChange = (rowId, field, value) => {
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === rowId);

      if (existingRow) {
        // Update the specific field in the existing row
        return prevSelectedRows.map((selectedRow) =>
          selectedRow._id === rowId ? { ...selectedRow, [field]: value } : selectedRow
        );
      } else {
        // Add a new row with the updated field
        return [...prevSelectedRows, { _id: rowId, [field]: value, ok: false, doc: false }];
      }
    });
  };

  const handleFetchDeficiencyChecklists = async () => {
    const response = await request('/deficiency-checklists-patient-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDeficiencyChecklistDataObjs({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDeficiencyChecklistDataObjs({ loading: false });
    }
  };
  useEffect(() => {
    handleFetchDeficiencyChecklists();
  }, []);

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Deficiency Checklist
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn id={'Submit'} type="submit" variant="contained">
                  Save
                </CustomButtonn>
                <CustomButtonn id={'Exit'} variant="contained">
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Grid container spacing={2}>
              <Grid item xs={3} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    IPD No
                  </Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="ipd_no"
                    placeholder=""
                  />
                  <Button
                    sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                    variant="contained"
                    onClick={fetchIpdPatient}
                  >
                    <SearchIcon />
                  </Button>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Adm. Date
                  </Typography>
                  <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="" name="adm_date" type="date" />
                </Stack>
              </Grid>
              <Grid item xs={3} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>UHID</Typography>
                  <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="Search By Schedule" name="uhid" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Dis. Date
                  </Typography>
                  <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="" name="discharge_date" type="date" />
                </Stack>
              </Grid>
              <Grid item xs={3} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Patient Name</Typography>
                  <TextField sx={{ flex: 0.8 }} name="patient_name" placeholder="Enter Name" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Analysis Date
                  </Typography>
                  <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="" name="analysis_date" type="date" />
                </Stack>
              </Grid>
              <Grid item xs={3} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Consultant</Typography>
                  <TextField sx={{ flex: 0.8 }} name="consultant" placeholder="Enter Name" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Ward</Typography>
                  <TextField sx={{ flex: 0.8 }} name="ward" placeholder="Enter ward" disabled />
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', minHeight: '20rem', gap: 1 }}>
                <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 1, minHeight: '20rem' }}>
                  <Table
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={deficiencyChecklistDataObj?.data || []}
                    columns={ADD_Diagnosis}
                    size="small"
                    showOk={true}
                    showDoc={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    showInputField={true}
                    handleInputChange={handleInputChange}
                    inputValues={inputValues}
                    selectedRows={selectedRows}
                  />
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 1, minHeight: '20rem' }}>
                  <Table
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={deficiencyChecklistDataObjs?.data || []}
                    columns={ADD_Surgery}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={ipdRegistrationOpenDialogue}
        onClose={() => setIpdRegisterationOpenDialogue(false)}
        PaperProps={{ sx: { width: '70%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            IPD Patient Details
          </Typography>
          <IconButton onClick={() => setIpdRegisterationOpenDialogue(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
               width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={ipdInput}
            onChange={handleIpdChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={IPD_TABLE_COLUMNS}
          data={indoorRegisterationDataObj.data || []}
          loading={indoorRegisterationDataObj.loading}
          onRowClick={(row) => {
            handleIpdRow(row);
          }}
        />
        ;
      </Dialog>
    </>
  );
};
